export default "__VITE_ASSET__wquVOf8J__"